<template lang="pug">
  BasePopup.b-user-select-popup(v-on="$listeners")
    UserSelectTile._content(v-bind="$attrs" v-on="$listeners" inPopup)
</template>

<script>
import UserSelectTile from '@/components/UserSelectTile.vue';
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'UserSelectPopup',
  components: { BasePopup, UserSelectTile },
  model: { prop: 'selected', event: 'change' },
  props: {
    opened: Boolean,
  },
};
</script>

<style scoped lang="scss">
.user-select-popup {
  &__content {
    width: 940px;
    max-width: 100%;
    max-height: calc(95vh - 60px);
   }
}
</style>
